import { render } from "./CompanyAddress.vue?vue&type=template&id=414e0bff&scoped=true"
import script from "./CompanyAddress.vue?vue&type=script&lang=js"
export * from "./CompanyAddress.vue?vue&type=script&lang=js"

import "./CompanyAddress.vue?vue&type=style&index=0&id=414e0bff&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414e0bff"]])

export default __exports__